module.exports = __webpack_public_path__ + "static/media/image3.ba4984c9.svg";